import { Skeleton, SkeletonItem, mergeClasses } from '@fluentui/react-components';
import { useStyles } from './styles.js';

type LoadingSkeletonProps = {
    absolute?: boolean;
    padding?: boolean;
};

export function LoadingSkeleton({ absolute, padding = true }: LoadingSkeletonProps) {
    const styles = useStyles();

    return (
        <Skeleton
            className={mergeClasses(
                styles.skeleton,
                absolute && styles.skeletonAbsolute,
                padding && styles.skeletonPadding
            )}
        >
            <SkeletonItem className={styles.skeletonItem} />
        </Skeleton>
    );
}
